<!--suppress ALL -->
<template>
  <detail-template :classCustom="['detail-docs']">
    <template #content>
      <i @click="goBack" class="back-icon border-radius fal fa-arrow-right"></i>
      <div class="header">
        <div class="docTags">
          <el-tag
            v-if="vbIncomingDoc.docTypeName"
            size="medium"
            class="margin-right-5"
            >{{ vbIncomingDoc.docTypeName }}
          </el-tag>

          <tdhvp-doc-priority-tag
            v-if="!!vbIncomingDoc.priorityName"
            :priorityName="vbIncomingDoc.priorityName"
            class="margin-right-5"
          >
          </tdhvp-doc-priority-tag>
        </div>

        <h4 class="title-name">{{ vbIncomingDoc.quote }}</h4>
        <tdhvp-doc-download
          :docId="id"
          :docType="ATTACHMENT_OBJECT_TYPE.VB_DEN"
          :userDeptRoleId="userDeptRoleId"
        ></tdhvp-doc-download>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div class="group__info margin-top-10 padding-bottom-10">
            <div class="title font-size__medium">Thông tin</div>
            <div class="ctn">
              <div class="list-info width__100">
                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">Ngày đến:</div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      vbIncomingDoc.incomingDate
                        | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                        })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Số ký hiệu:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbIncomingDoc.docCode || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Ngày văn bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      vbIncomingDoc.docDate
                        | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                        })
                    }}
                  </div>
                </div>

                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="vbIncomingDoc.forwardDeptName"
                >
                  <div class="label font-size__small txt-right">
                    Đơn vị chuyển tiếp :
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbIncomingDoc.forwardDeptName }}
                  </div>
                </div>

                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="vbIncomingDoc.fromDeptName"
                >
                  <div class="label font-size__small txt-right">Nơi gửi:</div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbIncomingDoc.fromDeptName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">Hạn xử lý:</div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      vbIncomingDoc.deadlineDate
                        | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY HH:mm"
                        })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Số trang/Số bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbIncomingDoc.numberOfPage || "-" }} /
                    {{ vbIncomingDoc.numberOfCopy || "-" }}
                  </div>
                </div>

                <tdhvp-doc-histories
                  v-if="!!vbIncomingDoc && !!vbIncomingDoc.tdhvpHistory"
                  :tdhvpHistory="vbIncomingDoc.tdhvpHistory"
                ></tdhvp-doc-histories>
              </div>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
    </template>
  </detail-template>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../../constants";
import dateFormatter from "../../../filters/dateFormatter";
import goBackMixin from "../../../mixins/goBackMixin";
import { vbIncomingDocTdhvpViewService } from "../../../services/tdhvp/vbIncomingDocTdhvpViewService";
import BreakWordSpan from "../../adminstration/ketluan/break-word-span";
import DetailTemplate from "../../common/detail";
import TdhvpDocDownload from "../common/tdhvp-doc-download";
import TdhvpDocHistories from "../common/tdhvp-doc-histories";
import TdhvpDocPriorityTag from "../common/tdhvp-doc-priority-tag";

export default {
  components: {
    TdhvpDocDownload,
    TdhvpDocHistories,
    BreakWordSpan,
    TdhvpDocPriorityTag,
    DetailTemplate,
    VuePerfectScrollbar
  },

  mixins: [goBackMixin],
  filters: { dateFormatter },

  data() {
    return {
      vbIncomingDoc: {},
      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    userDeptRoleId() {
      return this.$store.getters.userDeptRoleId;
    }
  },

  watch: {
    id() {
      this.initPage();
    }
  },

  async created() {
    await this.initPage();
  },

  methods: {
    async initPage() {
      await this.loadVbIncomingDoc();
    },

    loadVbIncomingDoc() {
      return vbIncomingDocTdhvpViewService
        .findById(this.id)
        .then(response => (this.vbIncomingDoc = response.data));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/thdvp/doc-in/tdhvp-doc-in-detail.vue